import React from 'react';
import styled from '@grebban/style-system-react';
import Text from 'components/Text';
import { useTranslation } from 'react-i18next';
import { above } from '@fogia/core-web/utils/mediaqueries';

const Wrapper = styled('div')`
    padding: 0 12px;

    ${above['desktop.sm']} {
        padding: 0 40px;
    }
`;

const SearchTerm = styled('span')`
    color: var(--ui-secondary-aa, #d53a17);
`;

const ContactLink = styled('a')`
    text-decoration: underline;
    color: inherit;
`;

const TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, null, 'Primary/15_120_510_-1'];

const NoResults = ({ searchTerm }: { searchTerm: string }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Text typography={TYPOGRAPHY}>
                {t('search.no_results_prefix')}
                <SearchTerm>&quot;{searchTerm}&quot;</SearchTerm>
                {t('search.no_results_suffix')}{' '}
                <ContactLink href={t('search.no_results_contact_url')}>
                    {t('search.no_results_contact_label')}
                </ContactLink>
                .
            </Text>
        </Wrapper>
    );
};

export default NoResults;
